(function () {
    class CustomSwatch extends HTMLElement {
        constructor() {
            super();
            this.addEventListener("click", this.handleSwatchClick.bind(this), true);
        }

        handleSwatchClick(event) {
            const target = event.currentTarget;
            const item = target.closest(".js-product-listing");
            if (!item) return;

            // Toggle active class within this option group (color / size)
            const optionGroup = target.closest(".color-swatch, .size-swatch");
            if (optionGroup) {
              optionGroup.querySelectorAll("custom-swatch").forEach(sw => sw.classList.remove("active"));
            }
            target.classList.add("active");

            const variantID = target.dataset.variantId;
            const closestFormId = item.querySelector('.formBundleVariantId');

            // Build the full variant title from all currently-active swatches across option groups
            let fullName = '';
            const gridSwatches = target.closest(".product--grid__swatches");
            if (gridSwatches) {
              gridSwatches.querySelectorAll(".custom-swatch-btn.active").forEach(sw => {
                const title = sw.getAttribute('title') || '';
                fullName = fullName === '' ? title : (fullName + ' / ' + title);
              });
            }

            // Try to resolve a matching variant (with its featured_image) from the inline JSON
            let resolvedSrc = target.dataset.src || '';
            let resolvedId = variantID;
            try {
              const scriptEl = item.querySelector('.variantJSONdata');
              if (scriptEl) {
                const variants = JSON.parse(scriptEl.textContent);
                const match = variants.find(v => v.title === fullName);
                if (match) {
                  resolvedId = match.id;
                  if (match.featured_image && match.featured_image.src) {
                    resolvedSrc = match.featured_image.src;
                  }
                }
              }
            } catch (e) { /* fall through to data-src */ }

            // Fall back to the product's featured image if everything above resolved blank
            if (!resolvedSrc) {
              const firstImg = item.querySelector('.js-product-image img');
              if (firstImg) resolvedSrc = firstImg.src;
            }
            if (!resolvedSrc) return;

            // Normalize any protocol-relative URL
            if (resolvedSrc.indexOf('//') === 0) resolvedSrc = 'https:' + resolvedSrc;
            // Security: reject anything that isn't http(s) — blocks javascript:, data:, vbscript:, etc.
            if (!/^https?:\/\//.test(resolvedSrc)) return;

            // Update the product card image — cover both <img> and any <picture><source>
            const imageElement = item.querySelector(".js-product-image img");
            if (imageElement) {
              imageElement.src = resolvedSrc;
              imageElement.srcset = resolvedSrc;
              imageElement.removeAttribute('data-src');
              imageElement.removeAttribute('data-srcset');
            }
            item.querySelectorAll(".js-product-image picture source").forEach(src => {
              src.srcset = resolvedSrc;
            });

            // Sync any hidden form variant id so add-to-cart sends the right one
            if (closestFormId) closestFormId.setAttribute('value', resolvedId);
        }
    }
    customElements.define('custom-swatch', CustomSwatch);
})();

// Bundle product "add both" — delegated handler, no setTimeout race
document.addEventListener('click', function(event) {
  var button = event.target.closest('.addToCartBundleProduct');
  if (!button) return;
  var closestMainProductForm = button.closest('.product__section-contentWrapper');
  if (!closestMainProductForm) return;
  var mainATC = closestMainProductForm.querySelector('.product__section-content .product-add #addToCart');
  if (mainATC) mainATC.click();
  var closestProductInfo = button.closest('.product-info');
  if (closestProductInfo) {
    setTimeout(function() {
      var bundleATC = closestProductInfo.querySelector('.addBundleProduct');
      if (bundleATC) bundleATC.click();
    }, 500);
  }
}, true);



